import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "-mx-6 w-[calc(100%+48px)]" }
const _hoisted_2 = { class: "fixed top-20 left-0 z-10 bg-white px-6 py-4 shadow-[0_1px_0px_0px_rgba(0,0,0,0.08)] flex justify-between items-center w-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-semibold" }, "Back", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "w-[92px]" }, null, -1)
const _hoisted_5 = { class: "mt-[104px] max-w-[500px] mx-auto mb-6" }
const _hoisted_6 = { class: "col-span-2" }
const _hoisted_7 = { class: "flex items-center justify-end w-full space-x-3" }

import { onMounted, ref, computed } from "vue";
import UserLayout from "@/layouts/UserLayout.vue";
import FormSection from "./FormSection.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import TabComponent from "@/components/partials/TabComponent.vue";
import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";
import SuccessModal from "@/components/modals/SuccessModal.vue";
import TeleCpuLocationService from "@/classes/Settings/TeleCpuLocationService";
import TeleCpuOfficeService from "@/classes/Settings/TeleCpuOfficeService";
import { errorResponse } from "@/helpers/errorMessage";
import { useRoute, useRouter } from "vue-router";
import ArrowLeftIcon from "@/components/icons/arrowLeftIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreatePage',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const showConfirmation = ref<boolean>(false);
const showSuccess = ref<boolean>(false);
const successMessage = ref<string>("Data has been successfully updated!");
const form = ref<{ name: string }>({
	name: "",
});
const errors = ref<any>();
const locationId = computed<any>(() => route.params.location);

const tabs = ref<{ name: string; count: number; tab: string; href: string; allowed: boolean }[]>([
	{
		name: "Information",
		count: 0,
		tab: "",
		href: `/settings/telecpu-locations/${locationId.value}/view`,
		allowed: true,
	},
	{
		name: "Offices",
		count: 0,
		tab: "offices",
		href: `/settings/telecpu-locations/${locationId.value}/view?tab=offices`,
		allowed: true,
	},
]);

const save = (): void => {
	TeleCpuOfficeService.store(
		{
			location: locationId.value,
		},
		form.value
	)
		.then((response: any) => {
			showConfirmation.value = false;
			showSuccess.value = true;
			successMessage.value = response.data.message;
		})
		.catch((error: any) => (errors.value = errorResponse(error.response?.data?.errors)));
};

const redirectSuccess = (): void => {
	showSuccess.value = false;
	router.replace(`/settings/telecpu-locations/${locationId.value}/view?tab=offices`);
};

onMounted(() => {
	TeleCpuLocationService.edit({
		location: locationId.value,
	})
		.then((response: any) => {
			tabs.value[1].count = response.data.item.telcpus_count;
		})
		.catch((error: any) => console.log(error));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).replace(`/settings/telecpu-locations/${locationId.value.value}/view?tab=offices`)))
          }, [
            _createVNode(ButtonComponent, { customClass: "tertiary text-black hover:text-primary-600 transition" }, {
              default: _withCtx(() => [
                _createVNode(ArrowLeftIcon, { class: "object-contain w-6 h-6 mr-2" }),
                _hoisted_3
              ]),
              _: 1
            })
          ]),
          _hoisted_4
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(FormSection, {
            form: form.value,
            errors: errors.value
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(ButtonComponent, {
                    btnWidth: "primary",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => {showConfirmation.value=true;})
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Save Changes")
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(ConfirmationModal, {
                  typeTwo: true,
                  show: showConfirmation.value,
                  onCancel: _cache[2] || (_cache[2] = ($event: any) => (showConfirmation.value = false)),
                  onConfirm: _cache[3] || (_cache[3] = ($event: any) => (save())),
                  "cancel-text": "Cancel",
                  "action-text": "Confirm",
                  title: "Save Record",
                  content: "Are you sure you wish to save this record?"
                }, null, 8, ["show"]),
                _createVNode(SuccessModal, {
                  show: showSuccess.value,
                  onConfirm: _cache[4] || (_cache[4] = ($event: any) => (redirectSuccess())),
                  "action-text": "Close",
                  title: "Record saved!",
                  content: successMessage.value
                }, null, 8, ["show", "content"])
              ])
            ]),
            _: 1
          }, 8, ["form", "errors"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})